import { createAsyncThunk } from '@reduxjs/toolkit';
import { SubscriptionsApi } from '../../../api/base/Subscriptions';
import { ISubscriptionPlan } from '../../../api/base/Subscriptions/types';

export const fetchSubscriptionPlans = createAsyncThunk(
  'subscriptionPlans/fetchPlans',
  async (): Promise<ISubscriptionPlan[]> => {
    const response = await SubscriptionsApi.getSubscriptionPlans();
    return response.data.data;
  },
);
